import {lazy, Suspense} from 'react';
import {CircularProgress, Typography} from '@mui/material';
import {comparableListingUpdateFields} from 'lib/PropertyUtils';
import Formatter from 'lib/Formatter';

const LazyFeaturedComparablePrice = lazy(() => import('./FeaturedComparablePrice'));

const FallbackComponent = ({isSales = true, property = {}} = {}) => (
    <div className="FeaturedComparablePrice">
        <Typography sx={{ fontWeight: 600 }}>
            {isSales
                ? Formatter.currency(property.salePrice)
                : property[comparableListingUpdateFields[0]]}
        </Typography>
        <div className="menu-icon-loading">
            <CircularProgress classes={{root: 'loader'}} variant="indeterminate" size={27}/>
        </div>
    </div>
);

const FeaturedComparablePrice = (props) => (
    <Suspense fallback={<FallbackComponent {...props} />}>
        <LazyFeaturedComparablePrice {...props} />
    </Suspense>
);

export default FeaturedComparablePrice;
